import { combineReducers } from 'redux';
import walkthrough from './walkthrough.reducer';

var reducers = combineReducers({
    walkthrough: walkthrough
});

export default reducers;
